<div class="flex gap-2">
  <div class="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-900 flex-shrink-0">
    <flx-icon name="flowx-logo-white"></flx-icon>
  </div>
  <div class="grow text-sm text-white">
    <div class="flex items-center justify-between">
      <div>{{ message() }}</div>
      <flx-ai-loading-spinner
        (click)="cancelPendingRequest.emit()"
        class="h-5 inline-flex items-center cursor-pointer"
      />
    </div>
    @if (status()) {
      <div class="relative py-1 overflow-hidden">
        <div class="invisible">{{ status() }}</div>
        @for (status of [status()]; track status) {
          <span
            class="inline-flex items-center h-full absolute top-0"
            @fadeInOut
            >{{ status }}</span
          >
        }
      </div>
    }
  </div>
</div>
